export default [
	{
		columnName: 'id',
		columnDisplayName: 'Id',
		display: false
	},
	{
		columnName: 'laborOp',
		columnDisplayName: 'Labor Code',
		columnModifierName: 'labor-code',
		display: true,
		slot: 'laborOp',
		isSortable: true
	},
	{
		columnName: 'laborOpDescription',
		columnDisplayName: 'Description',
		columnModifierName: 'description',
		display: true,
		slot: 'laborOpDescription',
		isSortable: true
	},
	{
		columnName: 'laborHours',
		columnDisplayName: 'Time',
		columnModifierName: 'flat-rate-time',
		display: true,
		slot: 'laborHours',
		isSortable: false
	},
	{
		columnName: 'imported',
		columnDisplayName: '',
		columnModifierName: 'add-labor-code',
		display: true,
		slot: 'addLaborCode',
		isSortable: false
	}
];
